import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ShipmentIcon from '@material-ui/icons/LocalShippingOutlined';
import InvoiceIcon from '@material-ui/icons/AttachMoneyOutlined';
import CollectionsIcon from '@material-ui/icons/CollectionsOutlined';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SearchBarStyles from './__styles__/SearchBar.Styles';
import { Link } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { withNamespaces } from 'react-i18next';
import Notifications from './Notifications';
import NotificationsCircle from './NotificationsCircle';
import LayoutStyles from '../../styles/layout';
import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';
import { AppContext, AppConsumer } from '../../AppProvider';
import OrgSwitcher from './OrgSwitcher';
import { ADMIN, SHIPPER } from '../../constants/permissions';
import { isPermissible } from '../../components/Global/PermissionResolver';
import Autocomplete from './Inputs/Autocomplete';
import { globalSearch } from '../../graphQL/queries/globalQueries';
import {
  SEARCH_RESULT_TYPES,
  AUTOCOMPLETE_MAX_RESULTS
} from '../../constants/constants';

export class SearchBar extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired // comes from withApollo
  };

  state = {
    searchBy: '',
    anchorEl: null,
    profileMenuOpen: false,
    orgSwitcherOpen: false
  };

  _handleSearchByChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  _handleProfileMenuClick = () => {
    this.setState({
      anchorEl: document.getElementById('profileButton'),
      profileMenuOpen: true
    });
  };

  _handleProfileMenuClose = () => {
    this.setState({ anchorEl: null, profileMenuOpen: false });
  };

  _handleMyAccountClick = () => {
    this._handleProfileMenuClose();
    this.props.history.push('/myaccount');
  };

  _handleLogoutClick = () => {
    this._handleProfileMenuClose();
    this.props.auth.logout();
    this.props.client.clearStore();
  };

  _handleOrganizationSwitch = () => {
    const { isPropelAdministrator } = this.context.globalProps;

    this._handleProfileMenuClose();

    if (isPropelAdministrator) {
      this.props.history.push('/admin/organizations');
    } else {
      this.setState({ orgSwitcherOpen: true });
    }
  };

  _handleCloseOrgSwitcher = () => this.setState({ orgSwitcherOpen: false });

  globalSearch = async (ApolloClient, searchText) => {
    const { orgId } = this.context.globalProps.orgInfo;
    try {
      const data = await ApolloClient.query({
        query: globalSearch,
        variables: {
          orgId: orgId,
          limit: AUTOCOMPLETE_MAX_RESULTS,
          searchText: searchText
        },
        fetchPolicy: 'network-only'
      });
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
  _getSearchSuggestions = async value => {
    const { client } = this.props;

    try {
      const {
        data: {
          search: { global }
        }
      } = await this.globalSearch(client, value);

      const suggestions = global.map(result => {
        let info = null;
        if (result.value !== result.id) {
          // it wasn't found in the shipment # or invoice # so
          // need to provide the info
          info = `${result.type[0].toUpperCase()}${result.type
            .slice(1)
            .toLowerCase()} #${result.id}`;
        }
        const fieldName = result.fieldName ? result.fieldName : 'Reference';
        return {
          label: `${fieldName} ${result.value}`,
          info: info,
          icon:
            result.type === SEARCH_RESULT_TYPES.SHIPMENT
              ? ShipmentIcon
              : InvoiceIcon,
          ...result
        };
      });
      return suggestions;
    } catch (err) {
      return [];
    }
  };
  _onSearchValueChanged = change => {
    this.setState({ searchBy: change });
  };

  _onSearchSelected = selectedResult => {
    const { id, type } = selectedResult;
    const { history } = this.props;
    this.setState({ searchBy: '' });

    

    const defInvoice = '1234567890';

    switch (type) {
      case SEARCH_RESULT_TYPES.SHIPMENT:
        history.push('/shipments/' + id);
        break;
      case SEARCH_RESULT_TYPES.SHIPMENT_EXCEPTION_REASON:
        history.push('/shipments/' + id);
      case SEARCH_RESULT_TYPES.SHIPMENT_INVOICE:
        history.push('/shipments/' + id);
        break;
      case SEARCH_RESULT_TYPES.SHIPMENT_RATE:
        history.push('/shipments/' + id);
        break;
      case SEARCH_RESULT_TYPES.INVOICE:
        history.push('/invoices/' + defInvoice);
        break;
      case SEARCH_RESULT_TYPES.INVOICE_SYNOPSIS:
        history.push('/invoices/' + defInvoice);
        break;
      case SEARCH_RESULT_TYPES.HAZ_MAT:
        history.push('/custom-fields');
        break;
      case SEARCH_RESULT_TYPES.ORG_USER:
        history.push('/users');
        break;
      case SEARCH_RESULT_TYPES.USER:
        history.push('/users');
        break;
      case SEARCH_RESULT_TYPES.GL_CODE:
        history.push('/gl-codes');
        break;
      case SEARCH_RESULT_TYPES.LOCATION:
        history.push('/locations/' + id);
        break;
      case SEARCH_RESULT_TYPES.BRANDING:
        history.push('/general');
        break;
      case SEARCH_RESULT_TYPES.CARRIER:
        history.push('/carrier-relationships');
        break;
      case SEARCH_RESULT_TYPES.CARRIER_BUSINESS:
        history.push('/carrier-relationships/' + id);
        break;
      case SEARCH_RESULT_TYPES.CONTACT:
        history.push('/contacts');
        break;
      case SEARCH_RESULT_TYPES.PRODUCT_CATEGORY:
        history.push('/products');
        break;
      case SEARCH_RESULT_TYPES.PRODUCT:
        history.push('/products');
        break;
      case SEARCH_RESULT_TYPES.ORGANIZATION_EMAIL_ALIAS:
        history.push('/general');
        break;
        case SEARCH_RESULT_TYPES.ORG_ACCESSORIAL_SERVICE:
        history.push('/accessorials');
        break;
        case SEARCH_RESULT_TYPES.CUSTOM_FIELD:
        history.push('/custom-fields');
        break;
      case SEARCH_RESULT_TYPES.LCP_EXCEPTION_REASON:
        history.push('/lcp-exception-reasons');
        break;
      case SEARCH_RESULT_TYPES.FILE_UPLOAD:
        history.push('/files');
        break;

      default:
        history.push('/shipments/' + id);
        break;
    }
  };

  render() {
    const { classes, t } = this.props;
    const { searchBy, anchorEl, profileMenuOpen } = this.state;
    const { orgInfo, hasMultipleOrgs, currentOrgId } = this.context.globalProps;
    const { unassignedFiles } = this.context;
    const canEditFiles =
      isPermissible(this.context.globalProps, ADMIN, true) ||
      isPermissible(this.context.globalProps, SHIPPER, true);

    return (
      <AppConsumer>
        {({ showSearchbar }) => (
          <div
            className={classNames(classes.root, {
              [classes.hidden]: !showSearchbar
            })}
          >
            <div className={classes.searchWrapper}>
              <SearchIcon className={classes.searchRootIcon} />
              <Autocomplete
                name={'Search'}
                value={searchBy || ''}
                placeholder="Search..."
                label={''}
                classes={{
                  root: classes.searchRoot
                }}
                rowStyle={classes.searchRow}
                getSuggestions={this._getSearchSuggestions}
                onSuggestionSelected={this._onSearchSelected}
                focusInputOnSuggestionClick={false}
                onChange={change => {
                  this._onSearchValueChanged(change);
                }}
              />
            </div>
            {orgInfo && orgInfo.orgName && (
              <div
                className={classNames(classes.body1, classes.organizationName)}
              >
                {orgInfo.orgName}
              </div>
            )}
            <div>
              <Notifications />
              {canEditFiles && currentOrgId && (
                <Link to="/files">
                  <IconButton aria-label="Visibility" title={t('File Inbox')}>
                    <CollectionsIcon />
                    {unassignedFiles > 0 && <NotificationsCircle />}
                  </IconButton>
                </Link>
              )}
              <IconButton
                id="profileButton"
                aria-label="Visibility"
                title={t('My Profile')}
                aria-owns={anchorEl ? 'profile-menu' : undefined}
                aria-haspopup="true"
                onClick={this._handleProfileMenuClick}
              >
                <PersonIcon />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={profileMenuOpen}
                onClose={this._handleProfileMenuClose}
              >
                {hasMultipleOrgs && (
                  <MenuItem
                    onClick={this._handleOrganizationSwitch}
                    className={classes.menuItem}
                  >
                    {t('Switch Organization')}
                  </MenuItem>
                )}
                <MenuItem
                  onClick={this._handleMyAccountClick}
                  className={classes.menuItem}
                >
                  {t('My Account')}
                </MenuItem>
                <MenuItem
                  onClick={this._handleLogoutClick}
                  className={classes.menuItem}
                >
                  {t('Logout')}
                </MenuItem>
              </Menu>
              <OrgSwitcher
                open={this.state.orgSwitcherOpen}
                onClose={this._handleCloseOrgSwitcher}
              />
            </div>
          </div>
        )}
      </AppConsumer>
    );
  }
}

SearchBar.contextType = AppContext;
const searchBarTranslated = withNamespaces()(SearchBar);

export default withApollo(
  withRouter(
    withStyles(combineStyles(SearchBarStyles, LayoutStyles, TypographyStyles))(
      searchBarTranslated
    )
  )
);
